/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import YesNoSwitch from 'components/input/YesNoSwitch';
import GroupCheckbox from 'components/input/GroupCheckbox';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { BoolToString, checkEnableParseJSON, formatBoolean } from 'components/helper/helper';
import { getGeneral, updateGeneral } from 'app/testingSlice/testingSlice';
import { debounce } from 'lodash';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import Grid from '@mui/joy/Grid';
import { ModalCheckTestFields } from '../common/ModalCheckMissingFields';
import pageStatusService from 'services/pageStatusService';
import { PAGE_NAME } from 'constants/common';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';


interface Props {}

const GeneralInfoTest = (props: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const query = new URLSearchParams(useLocation().search);
  const [check, setCheck] = React.useState(query.get('check'));
  const [showModal, setShowModal] = React.useState(false);
  const [myGeneralState, setMyGeneralState] = React.useState<any>(null);
  const myGeneral:any = useAppSelector((store) => store.testing.myGeneral);
  const test = useAppSelector((store) => store.testing);
  const dispatch:any = useAppDispatch();
  const history:any = useHistory();
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const onReviewdAndComplete = () => {
    void toggleReviewedAndComplete(PAGE_NAME.GENERAL_TEST, reviewedAndComplete, setReviewedAndComplete);
  }
  const formik = useFormik({
    initialValues: {
      is_wish_self_report_scores: undefined,
      all_tests_wish_report_array: '',
      is_promotion_within_educational_system: undefined,
    },
    onSubmit: async (values) => {
      let frmObj: any = {};
      frmObj.is_SAT = formAllTest.values.is_SAT;
      frmObj.is_ACT = formAllTest.values.is_ACT;
      frmObj.is_AP_Subject = formAllTest.values.is_AP_Subject;
      frmObj.is_IB_Subject = formAllTest.values.is_IB_Subject;
      frmObj.is_CLEP = formAllTest.values.is_CLEP;
      frmObj.is_TOEFL = formAllTest.values.is_TOEFL;
      frmObj.is_PTE = formAllTest.values.is_PTE;
      frmObj.is_IELTS = formAllTest.values.is_IELTS;
      frmObj.is_DuoLingo = formAllTest.values.is_DuoLingo;

      const studentId = getUserId();
      const newValues:any = {
        student_id: studentId,
        is_wish_self_report_scores: formatBoolean(values.is_wish_self_report_scores),
        all_tests_wish_report_array: JSON.stringify(frmObj),
        is_promotion_within_educational_system: formatBoolean(
          values.is_promotion_within_educational_system
        ),
      };

      await dispatch(updateGeneral(newValues));
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    const nextRoute = Object.keys(test.roleTest).find((key) => test.roleTest[key] === true);
    history.push(nextRoute ? routers?.[nextRoute]?.path : routers.activities.path);
  };

  const handleCheckMissing = () => {
    setCheck('1');
    setShowModal(true);
  }

  const formAllTest = useFormik({
    initialValues: {
      is_SAT: false,
      is_ACT: false,
      is_AP_Subject: false,
      is_IB_Subject: false,
      is_CLEP: false,
      is_TOEFL: false,
      is_PTE: false,
      is_IELTS: false,
      is_DuoLingo: false,
    },
    onSubmit: () => {},
  });

  const getDetail = async () => {
    const studentId = getUserId();
    const token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      const pageStatus: {
        student_completed: boolean;
      } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.GENERAL_TEST);
      if(pageStatus) {
        setReviewedAndComplete(pageStatus.student_completed);
      }
      let res = await dispatch(getGeneral(studentId));
      const dataLoaded: any = res.payload;
      if (dataLoaded) {
        const values: any = {
          ...dataLoaded,
          is_wish_self_report_scores: BoolToString(dataLoaded.is_wish_self_report_scores),
          is_promotion_within_educational_system: BoolToString(
            dataLoaded.is_promotion_within_educational_system
          ),
        };

        formik.setValues(values);
        formAllTest.setValues(JSON.parse(dataLoaded.all_tests_wish_report_array));
      }
      setLoading(false);
      formik.setStatus('idle');
    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getDetail();
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto save function ==========
  React.useEffect(() => {
    if (formik.dirty) debounceSaving();
  }, [formik.values, formAllTest.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 800),
    []
  );
  // Auto save function ==========

  const testTakenOptionLocal = [
    { value: 'is_SAT', label: 'SAT Tests' },
    { value: 'is_ACT', label: 'ACT Tests' },
    { value: 'is_AP_Subject', label: 'AP Subject Tests' },
    { value: 'is_IB_Subject', label: 'IB Subject Tests' },
    { value: 'is_CLEP', label: 'CLEP Tests', mdCol: 12 },
    {
      value: 'is_TOEFL',
      label: 'TOEFL iBT',
      activeContent: 'English Language Tests',
      onChecked: (checked: boolean) => checked && setOpen(true),
    },
    {
      value: 'is_PTE',
      label: 'PTE Academic',
      activeContent: 'English Language Tests',
      onChecked: (checked: boolean) => checked && setOpen(true),
    },
    {
      value: 'is_IELTS',
      label: 'IELTS',
      activeContent: 'English Language Tests',
      onChecked: (checked: boolean) => checked && setOpen(true),
    },
    {
      value: 'is_DuoLingo',
      label: 'DuoLingo',
      activeContent: 'English Language Tests',
      onChecked: (checked: boolean) => checked && setOpen(true),
    },
  ];

  const handleChangeReportScores = (value: string) => {
    formik.setFieldValue('is_wish_self_report_scores', value);
    if (value === 'false') {
      formAllTest.setValues({
        is_SAT: false,
        is_ACT: false,
        is_AP_Subject: false,
        is_IB_Subject: false,
        is_CLEP: false,
        is_TOEFL: false,
        is_PTE: false,
        is_IELTS: false,
        is_DuoLingo: false,
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseModal = () => setShowModal(false);

  // Auto-Refresh myGeneralState
  useEffect(() => {
    setMyGeneralState({
      ...myGeneral,
    });
  }, [myGeneral]);


  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { percentOnProcess: 50, title: 'Report Tests', specialId: 'ReportTests'},
          { percentOnProcess: 100, title: 'International Applicants', specialId: 'InternationalApplicants'},
        ]}
        title="Standardized Testing"
        process={1}
        icon={<CalculateOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            className="gm-form-grid"
          >
            <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                General Info
              </span>
            </div>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12}>
                <div className="my-2">Let's put all your standardized testing in one place!</div>
              </Grid>
              <Grid xs={12} id="ReportTests">
                <YesNoSwitch
                  id="is_wish_self_report_scores"
                  className="mb-3"
                  logo="span-cm-logo"
                  label="In addition to sending official score reports as required by colleges, do you wish to self-report scores or future test dates for any of the following standardized tests: ACT, SAT/SAT Subject, AP, IB, CLEP, TOEFL, PTE Academic, and IELTS?*"
                  name="is_wish_self_report_scores"
                  onChange={(e: any) => handleChangeReportScores(e.target.value)}
                  values={formik.values.is_wish_self_report_scores}
                  isMissing={!formik.values.is_wish_self_report_scores && check}
                  disabled={reviewedAndComplete}
                />
              </Grid>
              
              <div id="InternationalApplicants">
              {formik.values.is_wish_self_report_scores === 'true' && (
                <>
                  <Grid xs={12}>
                    <GroupCheckbox
                      columns={isMobile ? 1 : 3}
                      label="Indicate all tests you wish to report. Be sure to include tests you expect to take in addition to tests you have already taken.*"
                      className="common-flag"
                      options={testTakenOptionLocal}
                      form={formAllTest}
                      mdCol={6}
                      isMissing={
                        !formAllTest.values?.is_SAT &&
                        !formAllTest.values?.is_ACT &&
                        !formAllTest.values?.is_AP_Subject &&
                        !formAllTest.values?.is_IB_Subject &&
                        !formAllTest.values?.is_CLEP &&
                        !formAllTest.values?.is_TOEFL &&
                        !formAllTest.values?.is_PTE &&
                        !formAllTest.values?.is_IELTS &&
                        !formAllTest.values?.is_DuoLingo &&
                        check
                      }
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                  
                  <Grid xs={12}>
                    <div className="text-field-light my-3"></div>
                  </Grid>
                  
                  <Grid xs={12}>
                    <YesNoSwitch
                      className="mb-3"
                      label="International applicants: Is promotion within your educational system based upon standard leaving examinations given at the end of lower and/or senior secondary school by a state or national leaving examinations board? (Students studying in the US typically answer no to this question.)*"
                      logo="span-cm-logo"
                      name="is_promotion_within_educational_system"
                      onChange={formik.handleChange}
                      values={formik.values.is_promotion_within_educational_system}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                </>
              )}
              </div>
            </Grid>
            <div className="row my-3 pt-3 border-top">
              <div className="col-md-6">
                <div className="text-left pt-3">
                  <div className="gm-btn-checkmissing"
                    onClick={() => handleCheckMissing()}
                  >
                    <SearchIcon/><span>Check missing values</span>
                  </div>
                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}  
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-start text-md-end">
                <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {test.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You will need to enter these test results manually into the applications.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>
        
        <ModalCheckTestFields
            show={showModal}
            onClose={handleCloseModal}
            data={{
              ...myGeneralState,
              all_tests_wish_report_array: checkEnableParseJSON(
                myGeneralState?.all_tests_wish_report_array
              ),
            }}
            page="genaral"
          />
      </Container>
    </>
  );
};

export const testTakenOption = [
  { value: 'is_SAT', label: 'SAT Tests' },
  { value: 'is_ACT', label: 'ACT Tests' },
  { value: 'is_AP_Subject', label: 'AP Subject Tests' },
  { value: 'is_IB_Subject', label: 'IB Subject Tests' },
  { value: 'is_CLEP', label: 'CLEP Tests' },
  {
    value: 'is_TOEFL',
    label: 'TOEFL iBT',
    activeContent: 'English Language Tests',
  },
  {
    value: 'is_PTE',
    label: 'PTE Academic',
    activeContent: 'English Language Tests',
  },
  {
    value: 'is_IELTS',
    label: 'IELTS',
    activeContent: 'English Language Tests',
  },
  {
    value: 'is_DuoLingo',
    label: 'DuoLingo',
    activeContent: 'English Language Tests',
  },
];
export default GeneralInfoTest;
